<ion-header>
  <ion-toolbar>
    <ion-button (click)="close()" expand="block" fill="clear" shape="round">
      <span><ion-icon name="close" size="large"></ion-icon></span>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button expand="block" fill="solid" translate>
      INTRODUCTION_TUTORIAL.GET_STARTED
    </ion-button>
  </ion-toolbar>
</ion-footer>